import { Fields } from '@measured/puck';

export type TextAlignProps = {
  textAlign: string;
};

export const textAlignField: Fields<TextAlignProps> = {
  textAlign: {
    type: 'select',
    label: 'Text align',
    options: [
      { label: 'Center', value: 'text-center' },
      { label: 'Right', value: 'text-right' },
      { label: 'Left', value: 'text-left' },
      { label: 'Justify', value: 'text-justify' },
    ],
  },
};
